import _ from 'lodash';

import { ICommunicationVariable } from '../../../lib/types/communication.types';
import { VARIABLE_GROUP_ORDER } from './variable-panel.constants';
import { IVariableGroup } from './variable-panel.types';

// Namespace = the token path's first segment ('player.firstName' -> 'player').
export const variableNamespace = (key: string): string => key.split('.')[0];

export const groupVariablesByNamespace = (variables: ICommunicationVariable[]): IVariableGroup[] => {
  const grouped = _.groupBy(variables, (variable) => variableNamespace(variable.key));
  const unknown = Object.keys(grouped).filter((namespace) => !VARIABLE_GROUP_ORDER.includes(namespace));
  return [...VARIABLE_GROUP_ORDER.filter((namespace) => grouped[namespace]), ...unknown]
    .map((namespace) => ({ namespace, variables: grouped[namespace] }));
};

// Token text the composer inserts/copies. `fallback` present (even '') appends
// the |default part; the server treats an empty default as a deliberate blank.
export const buildVariableToken = (key: string, fallback?: string): string =>
  (fallback === undefined ? `{${key}}` : `{${key}|${fallback}}`);
